import { Border } from "./Border";
import { BoxShadow } from "./BoxShadow";
import { Breakpoints } from "./Breakpoints";
import { Colors } from "./Colors";
import { FlexboxGrid } from "./FlexboxGrid";
import { Radius } from "./Radius";
import { Spacing } from "./Spacing";
import { Typography } from "./Typography";

const Theme = {
    // COLORS
    color: Colors,

    // RADIUS
    radius: Radius,

    // BORDERS
    border: Border,

    // BOX SHADOW
    shadow: BoxShadow,

    // SPACING
    spacing: Spacing,

    // TYPOGRAPHY
    typography:Typography,

    // BREAKPOINTS
    breakpoint: Breakpoints,

    // FLEXBOXGRID
    flexboxgrid: FlexboxGrid
}

export default Theme;